"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _aftersaleApi = _interopRequireWildcard(require("@/api/aftersaleApi.js"));
var aftersaleApi = _aftersaleApi;
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _pageCache = require("@/utils/pageCache");
var _settingRefund = _interopRequireDefault(require("./settingRefund.vue"));
var _nextState = _interopRequireDefault(require("./nextState.vue"));
var _openSkus = _interopRequireDefault(require("./openSkus.vue"));
var _financePendingAudit = _interopRequireDefault(require("./financePendingAudit.vue"));
var _static = require("../orderList/order/static");
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils.js"));
var _orderSend = _interopRequireDefault(require("../orderList/order/lists/orderSend.vue"));
var _compensation = _interopRequireDefault(require("./compensation.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SettingRefund: _settingRefund.default,
    NextState: _nextState.default,
    OpenSkus: _openSkus.default,
    OrderSend: _orderSend.default,
    Compensation: _compensation.default,
    FinancePendingAudit: _financePendingAudit.default
  },
  data: function data() {
    return {
      orderStateOption: _static.orderStateOption,
      constants: this.$constants,
      typeOpetion: [{
        value: 1,
        label: '待联系'
      }, {
        value: 2,
        label: '初次联系无回复'
      }, {
        value: 3,
        label: '资料收集'
      }, {
        value: 4,
        label: '商务洽谈'
      }, {
        value: 5,
        label: '签订合同'
      }, {
        value: 6,
        label: '合同终止'
      }],
      userOption: [{
        value: 1,
        name: '当前登陆人'
      }],
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      saleStateOption: [],
      saleTypeOption: [],
      isResponsibilityModalVisible: false,
      // 控制责任判定窗口的显示
      supplierPercentage: 0,
      customerPercentage: 0,
      platformPercentage: 0,
      supplierAmount: 0,
      customerAmount: 0,
      platformAmount: 0,
      aftersaleCostAmount: 0,
      currentitem: [],
      totalAmount: 0
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var routeOrderNo = this.$route && this.$route.query ? this.$route.query.orderNo : '';
    if (routeOrderNo) {
      this.listPram.orderCode = routeOrderNo;
    }
    this.handlerGetListData(this.listPram);
    this.initSearch();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return (0, _pageCache.refreshOnCacheReentry)(vm, function () {
        return vm.handlerGetListData(vm.listPram);
      });
    });
  },
  methods: {
    openResponsibilityModal: function openResponsibilityModal(row) {
      var _this = this;
      this.currentitem = row;
      aftersaleApi.getResponsible(row.id).then(function (response) {
        // 更新预计金额
        _this.supplierAmount = response.supplierAmount;
        _this.customerAmount = response.customerAmount;
        _this.platformAmount = response.platformAmount;
        _this.supplierPercentage = response.supplierPercentage;
        _this.customerPercentage = response.customerPercentage;
        _this.platformPercentage = response.platformPercentage;
      }).catch(function (error) {
        _this.$message.error('查询售后判责信息失败');
      });
      this.isResponsibilityModalVisible = true; // 显示责任判定窗口
    },
    // 提交责任判定
    submitResponsibility: function submitResponsibility() {
      var _this2 = this;
      if (this.currentitem.length === 0) {
        this.$message.error('该售后单没有售后商品，无法售后判责');
        return;
      }
      var totalPercentage = this.supplierPercentage + this.customerPercentage + this.platformPercentage;
      // 检查三个百分比之和是否超过100

      if (totalPercentage > 100) {
        this.$message.error('供应商、客户和平台的百分比之和不能超过100');
        return; // 阻止提交
      }
      var orderAftersaleItemRequest = this.currentitem.items.map(function (item) {
        return {
          orderItemId: item.orderItemId,
          // 订单项ID
          skuId: item.skuId,
          // SKU ID
          quantity: item.quantity,
          // 数量
          saleAmount: item.price // 售后金额
        };
      });
      var request = {
        orderAftersaleItemRequest: orderAftersaleItemRequest,
        responsibility: {
          supplierPercentage: this.supplierPercentage,
          customerPercentage: this.customerPercentage,
          platformPercentage: this.platformPercentage
        }
      };
      aftersaleApi.getCost(request).then(function (response) {
        // 更新预计金额
        _this2.supplierAmount = response.supplierAmount;
        _this2.customerAmount = response.customerAmount;
        _this2.platformAmount = response.platformAmount;
        _this2.aftersaleCostAmount = response.aftersaleCostAmount;
      }).catch(function (error) {
        console.error('调用售后判责接口出错:', error);
        _this2.$message.error('售后判责失败');
      });
    },
    transformState: _transformState.default,
    initSearch: function initSearch() {
      this.getSaleType();
      this.getAfterState();
    },
    handerSearch: function handerSearch() {
      var doRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (doRefresh == 1) {
        this.listPram = {
          page: 1,
          limit: this.$constants.page.limit[0]
        };
      }
      ;
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this3 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      aftersaleApi.ListArticle(pram).then(function (data) {
        _this3.listData = data;
        _this3.listLoading = false;
      }).catch(function (err) {
        _this3.listLoading = false;
      });
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this4 = this;
      this.$confirm('确定删除当前数据', '提示').then(function (result) {
        suplierCouponsApi.DelArticle(rowData).then(function (data) {
          _this4.$message.success('删除数据成功');
          _this4.handerSearch(1);
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail() {
      this.$refs['OrderDetailRef'].openDetail();
    },
    // 导出
    exportsAftersale: function exportsAftersale() {
      aftersaleApi.exportSale(this.listPram).then(function (res) {
        window.open(res.fileName);
      });
    },
    // 退款操作
    handleRefund: function handleRefund(aftersaleNo) {
      this.$refs['SettingRefundRef'].initOpen(aftersaleNo);
    },
    // 售后追踪-状态流转
    goNextState: function goNextState(row) {
      this.$refs['NextStateRef'].initOpen(row);
    },
    handerFinaceAudit: function handerFinaceAudit(row) {
      this.$refs['FinancePendingAuditRef'].initOpen(row);
    },
    handerAftersale: function handerAftersale() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var initInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // type: 0-创建售后
      this.$router.push({
        path: "/order/aftersale/aftersaleDetail/".concat(initInfo.aftersaleNo ? initInfo.aftersaleNo : 0, "/").concat(initInfo.orderNo ? initInfo.orderNo : 0, "/").concat(type)
      });
    },
    // 查看sku详细信息
    openSkuDetail: function openSkuDetail(skuItems) {
      this.$refs['OpenSkusRef'].initOpen(skuItems);
    },
    // 获取售后类型
    getSaleType: function getSaleType() {
      var _this5 = this;
      this.saleTypeOption = [];
      aftersaleApi.getAfterType().then(function (res) {
        _this5.saleTypeOption = res || [];
      });
    },
    // 获取售后状态
    getAfterState: function getAfterState() {
      var _this6 = this;
      this.saleStateOption = [];
      aftersaleApi.getAfterState().then(function (res) {
        _this6.saleStateOption = res || [];
      });
    },
    sendOrder: function sendOrder(id) {
      this.$refs['OrderSendRef'].openInit({
        id: id
      });
    },
    saveAftersale: function saveAftersale() {
      var _this7 = this;
      var totalPercentage = this.supplierPercentage + this.customerPercentage + this.platformPercentage;
      // 检查三个百分比之和是否超过100

      if (totalPercentage > 100) {
        this.$message.error('供应商、客户和平台的百分比之和不能超过100');
        return; // 阻止提交
      }
      if (totalPercentage < 100) {
        this.$message.error('供应商、客户和平台的百分比之和不能小于100');
        return; // 阻止提交
      }
      var responsibility = {
        id: this.currentitem.id,
        supplierPercentage: this.supplierPercentage,
        customerPercentage: this.customerPercentage,
        platformPercentage: this.platformPercentage,
        supplierAmount: this.supplierAmount,
        customerAmount: this.customerAmount,
        platformAmount: this.platformAmount,
        aftersaleCostAmount: this.aftersaleCostAmount
      };
      aftersaleApi.saveResponsible(responsibility).then(function (data) {
        _this7.$message.success('更新售后判责成功！');
      }).catch(function () {
        _this7.$message.error('更新售后判责失败');
      });
      this.handerSearch(0);
      this.isResponsibilityModalVisible = false; // 显示责任判定窗口
    },
    handleCompensation: function handleCompensation(id) {
      this.$refs.CompensationRef.initOpen(id);
    }
  }
};